<template>
    <div>
        <div
                :class="[
      'el-color-picker',
      colorDisabled ? 'is-disabled' : '',
      colorSize ? `el-color-picker--${ colorSize }` : ''
    ]"
                v-clickoutside="hide">
            <div class="el-color-picker__mask" v-if="colorDisabled"></div>
            <div class="el-color-picker__trigger" @click="handleTrigger">
      <span class="el-color-picker__color" :class="{ 'is-alpha': showAlpha }">
        <span class="el-color-picker__color-inner"
              :style="{
            backgroundColor: displayedColor
          }"></span>
        <span class="el-color-picker__empty el-icon-close" v-if="!value && !showPanelColor"></span>
      </span>
                <span class="el-color-picker__icon el-icon-arrow-down" v-show="value || showPanelColor"></span>
            </div>
            <picker-dropdown
                    ref="dropdown"
                    :class="['el-color-picker__panel', popperClass || '']"
                    v-model="showPicker"
                    @pick="confirmValue"
                    @clear="clearValue"
                    :color="color"
                    :show-alpha="showAlpha"
                    :predefine="predefine">
            </picker-dropdown>
        </div>
        <div class="picker">
            <strong>
                Przekopiuj bazowy kolor:
            </strong>
            <div class="samples">
                <div class="sample" v-for="color in $store.state.colors" @click="copyColor(color.color)">
                    <span class="sample__box" :style="{background: color.color}"></span>
                    <span>{{ color.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {ColorPicker} from 'element-ui'

    export default {
        extends: ColorPicker,
        mounted () {
            this.$store.dispatch('fetchColors')
        },
        methods: {
            clearValue () {
                this.$emit('input', '');
                this.$emit('change', '');
                this.showPanelColor = false;
                this.showPicker = false;
                this.resetColor();
            },
            copyColor (color) {
                this.$emit('input', color);
                this.$emit('change', color);
                this.showPanelColor = false;
                this.showPicker = false;
                this.resetColor();
            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-color-picker {
        display: inline-block;
        padding-top: 2px;
        margin-right: 20px;
    }
    .picker {
        vertical-align: top;
        display: inline-block;
    }
    .sample {
        cursor: pointer;
        display: inline-block;
        margin-right: 15px;

        &__box {
            vertical-align: middle;
            display: inline-block;
            height: 1em;
            width: 1em;
        }
    }
</style>


// WEBPACK FOOTER //
// ColorPicker.vue?0f164aa8